export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL ?? "https://rest.loft.al/"

export const API_PUBLIC = 'api/'